@if (customSegment) {
  <p class="u-marginBottom-8">
    {{ customSegment.title | translationLookup: ['@@groupCustomSegmentTitle'] }}
    @if (!(customSegment.privacy_settings?.editable_by_self ?? true)) {
      <ng-container [ngTemplateOutlet]="readOnlySegment"></ng-container>
    }
  </p>
  <p class="color-grey-300 u-marginBottom-8">
    {{
      customSegment.description
        | translationLookup: ['@@groupCustomSegmentDescription']
    }}
  </p>
}
<ng-template #readOnlySegment>
  @if (userIsAnyAdmin) {
    <mat-icon
      [ngStyle]="{ 'vertical-align': 'text-bottom' }"
      [nzTooltipMouseEnterDelay]="0.5"
      class="md-16 color-grey-300 u-marginLeft-8"
      fontSet="material-icons-outlined"
      nz-tooltip="User will not be able to edit this attribute."
      i18n-nz-tooltip="@@groupSegment.nonEditableTooltipAdmin"
      >lock</mat-icon
    >
  } @else {
    <mat-icon
      [ngStyle]="{ 'vertical-align': 'text-bottom' }"
      [nzTooltipMouseEnterDelay]="0.5"
      class="md-16 color-grey-300 u-marginLeft-8"
      fontSet="material-icons-outlined"
      nz-tooltip="You do not have permissions to edit this attribute."
      i18n-nz-tooltip="@@groupSegment.nonEditableTooltipUser"
      >lock</mat-icon
    >
  }
</ng-template>
